export enum PlatformMissingDataType {
  SALARY = 'salary',
  START_DATE = 'start-date',
  DOCUMENTS = 'documents',
  SKILLS = 'skills',
  ISA = 'isa',
}
